import React from 'react'

const stacked_chart = () => {
  return (
    <div>stacked_chart</div>
  )
}

export default stacked_chart